import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EntityToAccountRuleItem  {
    _originalTypeClassName = "zERP.BO.EntityToAccountRuleItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EntityToAccountRuleItem.translate = translateService;
}
this.Items = [];
this.Rule = new Domain.AccountLocatorRule();
this.Id = null;
this.ShowOnUI = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ShowOnUI:any;
Items:any;
Rule:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.EntityToAccountRuleItem.removeItems($this, $this.Items[0]);
                }

                Domain.EntityToAccountRuleItem.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EntityToAccountRuleItem.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EntityToAccountRuleItem.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }
static setRule = ($this, value) => {
var oldValue = $this.Rule;
$this.Rule = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}